export const PARTNER_COMMISSION_STATUS_LABELS = {
  Calculated: "محاسبه‌شده",
  PendingManualApproval: "در انتظار تأیید دستی",
  Approved: "تأییدشده",
  Rejected: "ردشده",
  PayoutPendingApproval: "در انتظار تأیید تسویه",
  PayoutApproved: "تسویه تأییدشده",
  Paid: "پرداخت‌شده",
};

export const PARTNER_PAYOUT_STATUS_LABELS = {
  Requested: "درخواست‌شده",
  Approved: "تأییدشده",
  Rejected: "ردشده",
  Paid: "پرداخت‌شده",
  Cancelled: "لغوشده",
};

export const getCommissionStatusChipColor = (status) => {
  const s = String(status || "").toLowerCase();
  if (s === "paid") return "success";
  if (s === "approved" || s === "payoutapproved") return "info";
  if (s === "rejected") return "error";
  if (s === "pendingmanualapproval" || s === "payoutpendingapproval") return "warning";
  return "default";
};

export const getPayoutStatusChipColor = (status) => {
  const s = String(status || "").toLowerCase();
  if (s === "paid") return "success";
  if (s === "approved") return "info";
  if (s === "rejected" || s === "cancelled") return "error";
  if (s === "requested") return "warning";
  return "default";
};

export const TEAM_ACCESS_DENIED_MESSAGE =
  "امکان مدیریت زیرمجموعه برای حساب شما فعال نیست.";
